/* Rotates .og-s images inside each .og-t pane. 3.8s hold + 1.2s fade, random start offset per pane,
   paused when off-screen or tab hidden, off entirely for prefers-reduced-motion. First slide stays the "hero". */
(function () {
  var HOLD = 3800;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    document.querySelectorAll('.og-t').forEach(function (t) {
      var s = t.querySelectorAll('img.og-s');
      if (!s.length || t._sl) return;
      t._sl = 1;
      var lab = document.createElement('span'); lab.className = 'ob-view'; lab.textContent = s[0].dataset.view || ''; t.appendChild(lab);
      if (s.length < 2) return;
      var d = document.createElement('div'); d.className = 'og-dots';
      s.forEach(function (_, i) { var b = document.createElement('i'); if (!i) b.className = 'on'; d.appendChild(b); });
      t.appendChild(d);
      var i = 0, timer = null, vis = false;
      function show(n) {
        s[i].classList.remove('on'); d.children[i].classList.remove('on');
        i = n; s[i].classList.add('on'); d.children[i].classList.add('on'); lab.textContent = s[i].dataset.view || '';
      }
      function tick() { show((i + 1) % s.length); }
      function start() { if (reduce || timer || !vis || document.hidden) return; timer = setTimeout(function loop() { tick(); timer = setTimeout(loop, HOLD); }, HOLD + Math.random() * 1800); }
      function stop() { clearTimeout(timer); timer = null; }
      new IntersectionObserver(function (e) { vis = e[0].isIntersecting; vis ? start() : stop(); }, { threshold: .25 }).observe(t);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  window.addEventListener('load', init);
})();
